export const setErrorPage = (fullscreen = false) => {
	const primaryArea = document.getElementById('primaryArea');
	primaryArea.classList.add('in-error');

	if (fullscreen) {
		const body = document.body;
		const topnavArea = document.getElementById('topnavArea');
		const secondaryLayout = document.getElementById('secondaryLayoutWrapper');

		secondaryLayout.style.setProperty('--sidenavAreaWidth', '0');
		secondaryLayout.style.setProperty('--primaryAreaWidth', '100vw');

		body.style = 'overflow: hidden; background-color: #3843d0';
		topnavArea.style = 'display: none';
	}

	primaryArea.innerHTML = `
      <div id="mf-ErrorPage" class="mf-ErrorPage ${fullscreen ? 'fullscreen' : ''}">
        ${fullscreen ? '<img src="/static/mstile-150x150.png" />' : ''} 
        <div>
          ${
											fullscreen
												? '<strong>Failed to retrieve your Portal</strong>'
												: "<strong>Couldn't load this resource</strong>"
										}           
          <div class="mf-ErrorPage__message">
            <br>
            <p>We are sorry to let you know that an unknown error has occurred.</p>
            <p>Please reach to your account manager if the problem persists.</p>
            <br/>
            <a href=".">Reload</a>
          </div>
        </div>
      </div>
      `;
};

export const removeErrorPage = () => {
	const primaryArea = document.getElementById('primaryArea');
	const errorElement = document.getElementById('mf-ErrorPage');

	primaryArea.classList.remove('in-error');
	errorElement?.remove();
};

/**
 * Pushes an error notification throught snackbar if defined
 * otherwise uses the native window.alert
 *
 * @param {String} message
 * @param {Object} payload
 */
export const pushNotificationError = (message, options) => {
	if (window.Snackbar) {
		window.Snackbar.show({ text: message, customClass: 'is-alert', ...options });
	} else {
		alert(message);
	}
};
